import React from 'react'

function ComingSoon() {
  return (
   <main>
     <div class="container-fluid">
          
            <div class="row">
                <div class="col-12 p-0">
                    <div class="coming-soon">
                        <div class="coundown-timmer p-5">
                            <div class="content">
                                <h2 class="text-dark">Comming Soon</h2>
                            </div>
                            <div class="timmer-content">
                                <div class=" numbers">
                                    <span class="" id="days">00</span>
                                    <span>Days</span>
                                </div>
                                <span>:</span>
                                <div class="numbers">
                                    <span class="" id="hours">00</span>
                                    <span>Hours</span>
                                </div>
                                <span>:</span>
                                <div class="numbers">
                                    <span class="" id="minutes">00</span>
                                    <span>Minutes</span>
                                </div>
                                <span>:</span>
                                <div class="numbers">
                                    <span class="" id="seconds">00</span>
                                    <span>Second</span>
                                </div>
                            </div>

                                                       <div class="copy-right-section mt-3">
                              

                            </div>


                        </div>
                    </div>
                </div>
            </div>
          
        </div>
   </main>
  )
}

export default ComingSoon